export default __webpack_public_path__ + "static/media/logo-dark-short.3cb2822e.png";